import { Sprite, Texture, Text } from 'pixi.js';
import QuestData from './helper/getQuestData';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { EVENTS } from '../../lib/constants';
import { PromptView } from '../../view/prompt/PromptView';

class QuestClaimController {
	constructor(vc, conf) {
		this.config = conf;
		this.item_id = GameConfigs.quest_claim.activated_item;
		if (vc.getChildByName(this.config.item, true)) {
			this.vc = vc.getChildByName(this.config.item, true);
			let all_quest = QuestData.processQuest(GameConfigs.quest);
			this.quest_data = all_quest.items[this.config.id - 1];
			this.generateTitle();
			this.generateDesc();
			this.generateImg();
			this.vc.switchbtn.bg2.alpha = 0;
			this.vc.switchbtn.handler = this.switchHandler.bind(this);
			this.vc.switchbtn.item_id = this.quest_data.item.id;
			this.vc.switchbtn.prize = this.quest_data.item.prize;
			this.updateBtnState(false, this.vc);
			this.updateQuestState();
			window.addEventListener(EVENTS.QUEST_CLAIM, this, false);
			window.addEventListener(EVENTS.ERROR_MSG, this, false);
		} else {
			throw new Error(
				'QuestClaimController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.QUEST_CLAIM:
				GameConfigs.quest_claim = evt.detail.quest_claim;
				this.updateQuestState();
				break;
			case EVENTS.ERROR_MSG:
				window.removeEventListener(EVENTS.QUEST_CLAIM, this, false);
				window.removeEventListener(EVENTS.ERROR_MSG, this, false);
				break;
			default:
				break;
		}
	}

	generateImg() {
		switch (this.quest_data.prize.type) {
			case 'wild_respin':
				this.vc.itemimg = new Sprite(Texture.from('quest_reward_icon_4'));
				break;
			case 'bet_discount':
				this.vc.itemimg = new Sprite(Texture.from('quest_reward_icon_1'));
				break;
			case 'win_multiplier':
				this.vc.itemimg = new Sprite(Texture.from('quest_reward_icon_1'));
				break;
			case 'bonus_discount':
				this.vc.itemimg = new Sprite(Texture.from('quest_reward_icon_5'));
				this.vc.itemimgtext = new Text(
					`-${this.quest_data.prize.config.discount}%`,
					{
						fill: ['#e3d587', '#ae8d32'],
						fontFamily: 'Japanese',
						fontSize: 42
					}
				);
				this.vc.itemimgtext.anchor.set(0.5, 0);
				this.vc.itemimgtext.position.x = this.vc.itemimg.getBounds().width / 2;
				this.vc.itemimgtext.position.y = 30;
				this.vc.itemimg.addChild(this.vc.itemimgtext);
				break;
			case 'bonus_game':
				this.vc.itemimg = new Sprite(Texture.from('quest_reward_icon_2'));
				break;
			default:
				break;
		}
		this.vc.itemimg.position.x = 16;
		this.vc.itemimg.position.y = 16;
		this.vc.addChild(this.vc.itemimg);
	}

	generateDesc() {
		this.vc.itemsubtitle.position.set(16, 154);
		switch (this.quest_data.prize.type) {
			case 'bet_discount':
				this.vc.itemsubtitle.text = `Get ${this.quest_data.prize.config.discount}% of bet amount`;
				break;
			case 'win_multiplier':
				this.vc.itemsubtitle.text = `Get ${this.quest_data.prize.config.multiplier}x multiplier on each spin`;
				break;
			case 'bonus_discount':
				this.vc.itemsubtitle.text = `Get ${this.quest_data.prize.config.discount}% of required bonus buy amount`;
				break;
			case 'bonus_game':
				this.vc.itemsubtitle.text = `Get into free bonus round and try fortune`;
				break;
			case 'wild_respin':
				this.vc.itemsubtitle.text = `Get ${this.quest_data.prize.config.wilds}x random wild respin on reel`;
				break;
			default:
				break;
		}
	}

	generateTitle() {
		this.vc.itemheader = new Text(
			this.capitalizeWords(this.quest_data.prize.type),
			{
				fontSize: 24,
				fontFamily: 'Poppins SemiBold',
				fill: '#F09833'
			}
		);
		this.vc.itemheader.position.x = 16;
		this.vc.itemheader.position.y = 122;
		this.vc.addChild(this.vc.itemheader);
	}

	capitalizeWords(str) {
		let prize = str.split('_').join(' ');
		return prize
			.split(' ')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	}

	switchHandler(e) {
		if (
			this.quest_data.status === 'active' ||
			this.quest_data.status === 'inprogress'
		) {
			this.item_id = this.vc.switchbtn.item_id;
			console.log(
				`%cCONGRATS YOU HAVE ACTIVATED ${this.vc.switchbtn.item_id} item id. your bet level is ${GameConfigs.quest.bet_level}`,
				'color:purple; padding: 10px; background: green;'
			);
			GameConfigs.quest_claim = {
				...GameConfigs.quest_claim,
				item: this.quest_data,
				bet_level: GameConfigs.quest.bet_level,
				pending_item: this.item_id
			};
			GameConfigs.modal = 'prompt';
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'prompt' });
			GameConfigs.uiComponent.addView(PromptView);
		}
	}

	updateQuestState() {
		if (this.quest_data.status === 'completed') {
			this.vc.switchbtn.interactive = false;
			this.updateBtnState(true, this.vc);
		}
		if (this.quest_data.status === 'inprogress') {
			if (
				GameConfigs.quest_is_active &&
				this.vc.switchbtn.item_id === this.item_id
			) {
				this.vc.switchbtn.interactive = false;
				this.updateBtnState(true, this.vc);
			} else {
				this.vc.switchbtn.interactive = true;
				this.vc.switchbtn.bg2.alpha = 1;
				this.vc.switchbtn.bg.alpha = 0;
				this.vc.switchbtn.fg.alpha = 0;
			}
		}
	}

	updateBtnState(active, item) {
		item.switchbtn.setActive(active);
		item.switchbtn.bg.alpha = active ? 1 : 0;
		item.switchbtn.fg.alpha = active ? 0 : 1;
	}
}

export default QuestClaimController;
